// extracted by mini-css-extract-plugin
export default {"headerAndButtonsBox":"StatusMessages_headerAndButtonsBox__6WOb+","buttonsBox":"StatusMessages_buttonsBox__7-8xE"};